"use strict";

define('components/collapse-menu/collapse-menu',['jquery'], function ($) {
  $(document).on('click.collapse-menu', '[data-collapse-menu="auto"] .collapse-menu-closer', function () {
    var closer = $(this),
      open = null,
      el = closer.closest('[data-collapse-menu="auto"]');
    el.toggleClass('open');
    open = el.hasClass('open');
    el.trigger('toggle-collapse-menu');
    if (open) {
      el.trigger('open-collapse-menu');
    } else {
      el.trigger('close-collapse-menu');
    }
  });
});

